export const minWidthBannerImage = 800;
